module.exports = [{"key":"portal","name":"门户应用","data":[{"key":"function","name":"职能","data":[{"key":"0","name":"全部","selected":true},{"key":"1","name":"集团门户","selected":false},{"key":"2","name":"个人门户","selected":false},{"key":"3","name":"知识门户","selected":false},{"key":"4","name":"党群门户","selected":false},{"key":"5","name":"分公司门户","selected":false}]}]}]


//////////////////
// WEBPACK FOOTER
// ./src/mocks/screen_portal.json
// module id = 531
// module chunks = 0